import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Landing from "@/components/funnel/Landing";
import Quiz from "@/components/funnel/Quiz";
import LeadCapture from "@/components/funnel/LeadCapture";
import Analyzing from "@/components/funnel/Analyzing";
import Result from "@/components/funnel/Result";
import { QUESTIONS, MAX_POINTS_PER_Q } from "@/data/quiz";
import { markStepsComplete } from "@/hooks/useProgress";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Funnel() {
  const [step, setStep] = useState("landing");
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);

  const submit = async (contact) => {
    setStep("analyzing");
    const payload = {
      ...contact,
      answers: QUESTIONS.map((q) => {
        const opt = q.options[answers[q.id]];
        return {
          question: q.question,
          category: q.category,
          answer: opt.label,
          points: opt.points,
          max_points: MAX_POINTS_PER_Q,
        };
      }),
    };
    try {
      const { data } = await axios.post(`${API}/diagnostic/analyze`, payload);
      const weakSteps = [
        ...new Set(
          QUESTIONS.filter((q) => q.options[answers[q.id]].points <= 1).map((q) => q.step)
        ),
      ];
      const strongSteps = [
        ...new Set(
          QUESTIONS.filter((q) => q.options[answers[q.id]].points === MAX_POINTS_PER_Q).map((q) => q.step)
        ),
      ];
      markStepsComplete(strongSteps);
      localStorage.setItem("routehaul_lead_id", data.lead_id);
      localStorage.setItem(
        "routehaul_diagnostic_v1",
        JSON.stringify({
          score: data.score,
          tier: data.tier,
          ai_analysis: data.ai_analysis,
          category_scores: data.category_scores,
          answers: payload.answers,
          weakSteps,
          strongSteps,
          created_at: new Date().toISOString(),
        })
      );
      setResult({ ...data, weakSteps });
      setStep("result");
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong analyzing your results. Please try again.");
      setStep("lead");
    }
  };

  const restart = () => {
    setAnswers({});
    setResult(null);
    setStep("landing");
  };

  return (
    <div className="min-h-screen bg-white">
      {step === "landing" && <Landing onStart={() => setStep("quiz")} />}
      {step === "quiz" && (
        <Quiz
          answers={answers}
          setAnswers={setAnswers}
          onComplete={() => setStep("lead")}
          onExit={() => setStep("landing")}
        />
      )}
      {step === "lead" && <LeadCapture onSubmit={submit} onBack={() => setStep("quiz")} />}
      {step === "analyzing" && <Analyzing />}
      {step === "result" && result && <Result result={result} onRestart={restart} api={API} />}
    </div>
  );
}
